import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import PasswordInput from '../common/PasswordInput';
import LoadingSpinner from '../common/LoadingSpinner';

import Logo from '../assets/img/Kwenda-Logo.svg';
import styles from '../assets/css/auth.module.css';
import classNames from 'classnames';

import useApi from './useApi';

function ResetPassword() {
  const params = useParams();
  const navigate = useNavigate();
  const { actions: { submitPasswordReset }, errors, status, error } = useApi();

  const [payload, setPayload] = useState({
    password: null,
    passwordConfirmation: null,
  });

  const update = (key, value) => setPayload({ ...payload, [key]: value });

  const submit = (e) => {
    e.preventDefault();
    submitPasswordReset({ ...payload, token: params.token });
  };

  const redirectToLogin = () => navigate('../login');

  return (
    <div className={styles.auth_main}>
      <div className={styles.auth_form}>
        <div className={styles.auth_form_header}>
          <div>
            <h2>إنشاء كلمة مرور جديدة</h2>
            <p>قم بتغيير كلمة المرور</p>
          </div>
          <Link to='/'>
            <img className={styles.auth_logo} alt="Kwenda Logo" src={Logo} />
          </Link>
        </div>
        {status !== 'submitted' && <form>
          <PasswordInput
            label="كلمة المرور الجديدة"
            value={payload.password}
            onChange={(event) => update('password', event.target.value)}
            error={errors.password}
          />
          <PasswordInput
            label="تأكيد كلمة المرور"
            value={payload.passwordConfirmation}
            onChange={(event) => update('passwordConfirmation', event.target.value)}
            error={errors.passwordConfirmation}
          />
          <button className={classNames('button', styles.button)} onClick={submit}>
            تغيير كلمة المرور
            {status === 'submitting' && <LoadingSpinner />}
          </button>

          {error && <p
            className="error centered">
            <span className="iconify" data-icon="zondicons:exclamation-solid">
            </span>
            {error}
          </p>}
          <Link to="../login">العودة الى تسجيل الدخول</Link>
        </form>}
        {
          status === 'submitted' && <div className="success_message password_reset">
            <p>تم تغيير كلمة المرور بنجاح</p>
            <button className="button large-button redirect_button" onClick={redirectToLogin}>العودة الى تسجيل الدخول</button>
          </div>
        }
      </div>
    </div>
  );

}

export default ResetPassword;